import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';

/**
 * Ensures the inner button of nz-switch has an accessible name for screen readers.
 * Use with nz-switch when the host's aria-label is not forwarded to the inner button.
 */
@Directive({
  selector: 'nz-switch[appSwitchAriaLabel]',
  standalone: false
})
export class NzSwitchAriaLabelDirective implements AfterViewInit, OnDestroy {
  @Input() appSwitchAriaLabel = '';

  private innerButton: HTMLButtonElement | null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateButtonLabel();
  }

  ngOnDestroy(): void {
    this.innerButton = null;
  }

  private updateButtonLabel(): void {
    const label = this.appSwitchAriaLabel?.trim();
    if (!label) return;
    const button = this.el.nativeElement.querySelector?.('button');
    if (button) {
      this.innerButton = button;
      button.setAttribute('aria-label', label);
    }
  }
}
